module.exports = __webpack_public_path__ + "img/6.7abb9a4b.png";